import { Button } from '@/components/atoms/button';

interface DataTableDrawerActionFooterProps {
  onReset: () => void;
  onApply: () => void;
  resetDisabled?: boolean;
}

export function DataTableDrawerActionFooter({
  onReset,
  onApply,
  resetDisabled = false,
}: DataTableDrawerActionFooterProps) {
  return (
    <div className="flex gap-2 border-t px-5 py-4">
      <Button variant="outline" className="flex-1" disabled={resetDisabled} onClick={onReset}>
        Reset
      </Button>
      <Button className="flex-1" onClick={onApply}>
        Apply
      </Button>
    </div>
  );
}
